import {
    appRoles, sortDataType, sortDirection, systemElementGroups,
} from '../youwell-common/constants';

export const gridLayout = {
    xs: 12,
    sm: 12,
    md: 10,
    lg: 9,
    xl: 8,
};

export const contactEmail = 'post@vimo.no';

export const vimoElementGroups = {
    ...systemElementGroups,
    surveyForm: 'Kartlegging',
};

export const defaultRowsPrPage = 15;

export const userSortColumns = {
    name: 'name',
    role: 'role',
    updated: 'updated',
    email: 'email',
    phone: 'phone',
};

export const defaultUserSort = {
    columnName: userSortColumns.name,
    direction: sortDirection.asc,
    dataType: sortDataType.default,
};

export const defaultUserFilter = {
    search: '',
    role: '',
};

export const vimoCreateRoles = [appRoles.organizationAdmin, appRoles.therapist];
export const vimoRoles = [appRoles.organizationAdmin, appRoles.therapist, appRoles.contactPerson];
